const trackingParams = ['sri']

export const start = () => {
  window.addEventListener('single-spa:routing-event', event => {
    const url = new URL(event.detail.newUrl)

    const found = url.search
      ? trackingParams.filter(param => url.searchParams.has(param))
      : []

    if (!found.length) {
      return
    }

    for (const param of found) {
      url.searchParams.delete(param)
    }

    window.history.replaceState({}, document.title, url.pathname + url.search)
  })
}
